const getDefaultForm = () => ({
  Adjuntos: [],
  template: '',
  file: []
})
const getDefaultState = () => {
  return {
    form: getDefaultForm()
  }
}
  
const state = getDefaultState()
const getters = { form: state => state.form }
const mutations = {}
const actions = {
  resetForm ({ state }) {
    state.form = getDefaultForm()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
